<template>
    <div>
        <div class="form-group col-12">
            <label for="title">Title</label>
            <input
                id="title"
                v-model="page.title"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('title')
                }"
                dir="auto"
                placeholder="Title"
                @blur="$emit('on-title-change', page.title)"
            />
            <div class="invalid-feedback">
                {{ getError('title') }}
            </div>
        </div>
        <div v-if="!editMode || (editMode && page.id)" class="col-12">
            <small v-if="hasError('content')" style="color: #dc3545">
                {{ getError('content') }}
            </small>

            <content-builder
                v-model="page.content"
                label="Content"
                :sections="{ form: false }"
            />
        </div>
    </div>
</template>

<script>
import ContentBuilder from '@/components/elements/ContentBuilder';

export default {
    components: {
        ContentBuilder
    },

    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            page: {}
        };
    },

    watch: {
        page() {
            this.$emit('input', this.page);
        }
    },

    created() {
        this.page = { ...this.value };

        if (!this.page.content) {
            this.page.content = [];
        }
    },

    methods: {
        hasError(key) {
            return (
                this.validation.page[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.page,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
